<template>
  <div id="app">
    <router-view />
    <nav v-if="showTabbar" class="tabbar">
      <router-link
        :to="userInfoTo"
        class="tab-item"
        :class="{ active: $route.path === '/mine/userInfo' }"
      >
        <van-icon name="user-o" />
        <span>个人信息</span>
      </router-link>
      <router-link
        to="/square"
        class="tab-item"
        :class="{ active: $route.path === '/square' }"
      >
        <van-icon name="search" />
        <span>项目广场</span>
      </router-link>
      <router-link
        to="/projectSquare"
        class="tab-item"
        :class="{ active: $route.path === '/projectSquare' }"
      >
        <van-icon name="todo-list-o" />
        <span>我的项目</span>
      </router-link>
      <router-link
        to="/settlement"
        class="tab-item"
        :class="{ active: $route.path === '/settlement' }"
      >
        <van-icon name="cash-back-record-o" />
        <span>结算记录</span>
      </router-link>
    </nav>
  </div>
</template>


<script>
import { Icon } from "vant";
import { getStorage } from "@/utils/storage";

export default {
  name: "app",
  components: {
    [Icon.name]: Icon,
  },
  computed: {
    showTabbar() {
      return this.$route.path !== "/guide";
    },
    userInfoTo() {
      const content =
        this.$route.query.content || getStorage("wechat_content") || "";
      if (!content) {
        return { path: "/mine/userInfo" };
      }
      return { path: "/mine/userInfo", query: { content } };
    },
  },
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f5f5f5;
  height: 100vh;
  overflow: hidden;
}

::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  background: transparent !important;
  display: none !important;
}

*::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  background: transparent !important;
  display: none !important;
}

body {
  -webkit-overflow-scrolling: touch;
  overflow: hidden;
}

.page-scroll-container {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.page-scroll-container::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  display: none !important;
}

.tabbar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  background: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  padding-bottom: env(safe-area-inset-bottom);
}

.tab-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
  color: #999;
  text-decoration: none;
  font-size: 12px;
}

.tab-item.active {
  color: #1989fa;
}

.tab-item .van-icon {
  margin-bottom: 4px;
}
</style>
